const ProductCard = ({product}) => {
    return (
        <div 
        key={product._id} 
        className='w-full sm:w-[49%] md:w-[49%] lg:w-[32%] xl:w-[23%] 2xl:w-[18%] min-w-52 border
         rounded-md bg-white hover:shadow-lg transition-shadow duration-300 pb-4 flex flex-col gap-4'>
            <div className='w-full flex justify-center'>
                <img src={`${product.featuredImage}`} alt={`${product.name}`} className='w-full h-40 object-cover rounded-t-lg' />
            </div>
            <div className='w-full flex flex-col items-center gap-4 overflow-hidden'>
                <div className='flex flex-col items-center gap-4 text-center'>
                    <div className='font-bold text-lg text-gray-800 overflow-hidden text-ellipsis w-[98%]'>{product.name}</div>
                    <div className='text-gray-600 text-sm line-clamp-2 max-w-52 text-ellipsis overflow-hidden'>{product.description}</div>
                    <div className='text-gray-500 text-xs bg-gray-100 px-2 py-1 rounded border border-gray-200'>
                        {product.dimensions.width}/{product.dimensions.height}/R{product.dimensions.depth}
                    </div>
                </div>
                <div className='flex items-center gap-2'>
                    {product.discountedPrice ? (
                        <>
                            <div className='text-gray-500 line-through text-sm'>₺{product.regularPrice}</div>
                            <div className='border-l border-gray-300 h-6'></div>
                            <div className='text-green-600 font-bold text-lg'>₺{product.discountedPrice}</div>
                        </>
                    ) : (
                        <div className='text-gray-800 font-bold text-lg'>₺{product.regularPrice}</div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ProductCard;